import { Storage } from '../../dependencies';

export default Storage.createNamespace('companyId');
